const state = {
  corpId: '',
  userInfo: {},
  menuShow: false,
  jobsiteID: '',
  preJobsiteID: '',
  jobsiteName: '',
  jobsiteLocation: '',
  CreatorId: '',
  projectList: [],
  cropUser: [],
  projectUser: [],
  taskStatus: [],
  taskType: [],
  taskChecklistTemplates: [],
  taskTemplates: [],
  taskWorkType: [],
  taskGroup: [],
  reportType: [],
  plan: {},
  planCondition: {},
  showManagement: false,
  mockUserInfo: {},
  measureUnitType: '',
  temperatureUnit: '',
  M2Integration: false,
  corpName: '',
  userContactCorps: [],
  hasCloudGroup: false,
  avatar: '',
  planTabType: 'Grid',
  corporationCondition: {},
  projectCondition: {},
  corporationConditionOrderby: 'LastActivityTime desc',
  planConditionOrderby: 'CreatedOn desc',
  taskConditionOrderby: 'LastUpdatedOn desc',
  reportConditionOrderby: 'CreatedOn desc',
  productConditionOrderby: 'CreatedOn desc',
  photoConditionOrderby: 'CreatedOn desc',
  documentsConditionOrderby: 'CreatedOn desc'
}
export default state
